<template>

  <base-modal name="mediacontact-product-type-edit"
              toptitle="Produktart bearbeiten"
              :title="mediacontactProductType.name"
              :width="400"
              v-on="$listeners"
              v-bind="$attrs">
    <mediacontact-product-type-form :mediacontactProductType="mediacontactProductType" type="edit"/>
  </base-modal>

</template>

<script>
import MediacontactProductTypeForm from './MediacontactProductTypeForm.vue'

export default {
  name: 'MediacontactProductTypeEdit',
  components: { MediacontactProductTypeForm },
  props: {
    mediacontactProductType: Object
  }
}
</script>
